import React from "react";
import "./index.scss";

class NoEncontrado extends React.Component {
  render() {
    return (
      <div className="noencontrado__container">
        <div className="d-flex justify-content-center">
          <div className="noencontrado__info">
            <h1>404</h1>
            <div>
              <p>No pudimos encontrar la información que buscas.</p>
              <p>Regresa e intenta de otra forma.</p>
            </div>
          </div>
        </div>
        <div className="noencontrado__button d-flex justify-content-center mt-5">
          <a href="/vw/admin/aplicaciones" style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              type="button"
              className={"button_vw button_vw--primary"}
            >
              Ir al administrador
            </button>
          </a>
        </div>
      </div>
    );
  }
}

export default NoEncontrado;